module.exports = __webpack_public_path__ + "img/4.bc2dba8d.jpg";